export default class SequenceActionWrapper {
	constructor(action, context) {
		this.action = action;
		this.nextActionWrapper = null;
		this.break = false;
		this.context = context;
	}

	invoke() {
		if (!this.break && this.action != null)
			this.action.call(this.context, () => {
				if (this.nextActionWrapper != null) this.nextActionWrapper.invoke();
			});
	}
}
